export const DIAMOND_HEIGHT = 40;
export const DIAMOND_WIDTH = DIAMOND_HEIGHT * 1.75;
